import React from 'react';
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';

import CustomProductVariants from './src/@husky-x/gatsby-theme-husky/components/CustomProductVariants';

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'CustomProductVariants',
        component: CustomProductVariants,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
